import React from 'react'

/* doc
---
title: MessageBody
name: MessageBody
category: React - Bulma
parent: Message
---

A `MessageBody` component based on Bulma `.message-body`. This is used to wrap
the contents of a `Message` component.

This should be used as a child of the `Message` component.

See [Bulma Documentation](http://bulma.io/documentation/components/message/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <Message>
    <MessageBody>
      ...
    </MessageBody>
  </Message>
```
*/
function MessageBody(props) {
  const { className, children, ...rest } = props

  const classes = [
    'message-body',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default MessageBody
